import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { mapToEdgeTimeUnit } from '@modules/common/utils/mapToEdgeTimeUnit';
import { TimeRange, TimeUnit } from 'generated/graphql';

export const mapToEdgeTimeRange = (timeRange: DateTimeRange): TimeRange => {
  switch (timeRange.type) {
    case 'absolute':
      return {
        startAfter: (timeRange.startAfter?.unix() ?? 0) * 1000,
        endBefore: (timeRange.endBefore?.unix() ?? 0) * 1000,
      };
    case 'last':
      return {
        relative: {
          unit: mapToEdgeTimeUnit(timeRange.unit) ?? TimeUnit.Day,
          value: timeRange.value ?? 0,
        },
      };
    case 'since':
      return {
        startAfter: (timeRange.startAfter?.unix() ?? 0) * 1000,
      };
  }
};
